export interface INavItem {
  crumb     : string;
  title     : string;
  path?     : string;
  children? : INavItem[];
  menu?     : INavItem[];
}

const accountManagementMenu: INavItem[] = [{
  crumb : 'comments',
  title : 'Account Comments',
  path  : '/account-management/{id}/comments',
}, {
  crumb : 'invoices',
  title : 'Invoices',
  path  : '/account-management/{id}/invoices',
}, {
  crumb : 'auctions',
  title : 'Auctions',
  path  : '/account-management/{id}/auctions',
}, {
  crumb : 'partners',
  title : 'Partners',
  path  : '/account-management/{id}/partners',
}, {
  crumb : 'services-statistics',
  title : 'Account Statistics',
  path  : '/account-management/{id}/services-statistics',
}];

export const navItems: INavItem[] = [
  {
    crumb    : 'dashboard',
    title    : 'Dashboard',
    path     : '/dashboard',
    children : [
      {
        crumb : 'vin-decode-history',
        title : 'VIN Decode History',
        path  : '/dashboard/vin-decode-history',
      },
    ],
  },
  {
    crumb    : 'account-management',
    title    : 'Account Management',
    path     : '/account-management/search',
    children : [
      {
        crumb : 'search',
        title : 'Search',
        path  : '/account-management/search',
      },
      {
        crumb : 'add',
        title : 'Add New Account',
        path  : '/account-management/add',
      },
      {
        crumb : 'edit',
        title : 'Edit Account',
        path  : '/account-management/{id}/edit',
        menu  : accountManagementMenu,
      },
      {
        crumb : 'comments',
        title : 'Comments',
        path  : '/account-management/{id}/comments',
        menu  : accountManagementMenu,
      },
      {
        crumb : 'invoices',
        title : 'Invoices',
        path  : '/account-management/{id}/invoices',
        menu  : accountManagementMenu,
      },
      {
        crumb : 'auctions',
        title : 'Auctions',
        path  : '/account-management/{id}/auctions',
        menu  : accountManagementMenu,
      },
      {
        crumb : 'partners',
        title : 'Partners',
        path  : '/account-management/{id}/partners',
        menu  : accountManagementMenu,
      },
      {
        crumb : 'services-statistics',
        title : 'Account Statistics',
        path  : '/account-management/{id}/services-statistics',
        menu  : accountManagementMenu,
      },
    ],
    menu: [
      {
        crumb : 'search',
        title : 'Search',
        path  : '/account-management/search',
      },
      {
        crumb : 'add',
        title : 'Add a New Account',
        path  : '/account-management/add',
      },
      {
        crumb : 'users',
        title : 'Users',
        path  : '/account-management/users',
      },
      {
        crumb : 'salespersons',
        title : 'Salesperson Users',
        path  : '/account-management/salespersons',
      },
      {
        crumb : 'reports',
        title : 'Salespersons Commissions Reports',
        path  : '/account-management/reports',
      },
    ],
  },
  {
    crumb    : 'auctions',
    title    : 'Auctions',
    path     : '/auctions/search',
    children : [
      {
        crumb : 'details',
        title : 'Details',
        path  : '/auctions/{id}/details',
      },
      {
        crumb : 'photos',
        title : 'Photos',
        path  : '/auctions/{id}/photos',
      },
    ],
  },
  {
    crumb    : 'invoice-management',
    title    : 'Invoice Management',
    path     : '/invoice-management/search',
    children : [
      {
        crumb : 'current',
        title : 'Current',
        path  : '/invoice-management/current',
      },
      {
        crumb : 'over-thirty-days',
        title : 'Over Thirty Days',
        path  : '/invoice-management/over-thirty-days',
      },
      {
        crumb : 'over-sixty-days',
        title : 'Over Sixty Days',
        path  : '/invoice-management/over-sixty-days',
      },
      {
        crumb : 'over-ninety-days',
        title : 'Over Ninety Days',
        path  : '/invoice-management/over-ninety-days',
      },
      {
        crumb : 'invoice-history',
        title : 'Invoice History',
        path  : '/invoice-management/invoice-history',
      },
      {
        crumb : 'default-pricing',
        title : 'Default Pricing',
        path  : '/invoice-management/default-pricing',
      },
      {
        crumb : 'use-tax',
        title : 'Use Tax',
        path  : '/invoice-management/use-tax',
      },
    ],
  },
  {
    crumb    : 'registered-bidders',
    title    : 'Registered Bidders',
    path     : '/registered-bidders/search',
    children : [
      {
        crumb : 'edit',
        title : 'Edit User',
        path  : '/registered-bidders/{id}/edit',
      },
    ],
  },
  {
    crumb    : 'manage-intranet-users',
    title    : 'Manage Intranet Users',
    path     : '/manage-intranet-users/list',
    children : [
      {
        crumb : 'add',
        title : 'Add New User',
        path  : '/manage-intranet-users/add',
      },
      {
        crumb : 'edit',
        title : 'Edit User',
        path  : '/manage-intranet-users/{id}/edit',
      },
    ],
  },
  {
    crumb : 'national-ad-manager',
    title : 'National Ad Manager',
    path  : '/national-ad-manager/cards',
  },
];
